import pako from 'pako';
import { atob, btoa } from 'abab';

function uint8ToString(uint8Value: Uint8Array) {
  let buffer = 0x8000;
  let c: string[] = [];
  for (let i = 0; i < uint8Value.length; i += buffer)
    c.push(String.fromCharCode.apply(null, uint8Value.subarray(i, i + buffer)));

  return c.join('');
}

export const gzip = (str: string) => {
  if (str.startsWith('H4sIA')) return str;
  let s = uint8ToString(pako.gzip(str));
  return btoa(s) || s;
};

export const ungzip = (str: string) => {
  if (!str) return '';
  if (!str.startsWith('H4sIA')) return str;
  let chars = (atob(str.trim()) as string).split('').map(x => x.charCodeAt(0));

  return pako.ungzip(new Uint8Array(chars), { to: 'string' });
};
